import state from "@/store/coupon/state";
import actions from "@/store/coupon/actions";
import mutations from "@/store/coupon/mutations";
import getters from "@/store/coupon/getters";

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
};
